import styled from 'styled-components';
import {
  GridProps,
  JustifyContentProps,
  gridGap,
  justifyContent,
} from 'styled-system';

export const Container = styled.div<GridProps & JustifyContentProps>`
  display: inline-flex;
  width: 100%;
  ${gridGap};
  ${justifyContent};
`;
